import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { FlashService } from '@app/services/flash.service';
import { Observable, of } from 'rxjs';
import {
  catchError,
  map,
  switchMap,
  tap,
  exhaustMap,
  concatMap,
  mapTo
} from 'rxjs/operators';
import { ApiService } from '@app/services/api/api.service';
import {
    JobActionTypes,
    GetJobsInfo,
    GetJobsInfoSuccess,
    GetJobsInfoFail,
    Job
} from '@core/actions/job.actions';

@Injectable()
export class JobEffects {
  @Effect()
  GetJobsInfo$: Observable<Action> = this.actions$.pipe(
    ofType<GetJobsInfo>(JobActionTypes.GetJobsInfo),
    map(action => action.data),
    switchMap(data =>
      this.api.getJobInfo(data).pipe(
        map((jobs: any) => new GetJobsInfoSuccess(jobs)),
        catchError(error => of(new GetJobsInfoFail(error)))
      )
    )
  );

  constructor(
    private actions$: Actions,
    private api: ApiService,
    private fs: FlashService
  ) {}
}
